import { render, staticRenderFns } from "./SettingsSystemDispatch.vue?vue&type=template&id=a1e93568&"
import script from "./SettingsSystemDispatch.vue?vue&type=script&lang=js&"
export * from "./SettingsSystemDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1e93568')) {
      api.createRecord('a1e93568', component.options)
    } else {
      api.reload('a1e93568', component.options)
    }
    module.hot.accept("./SettingsSystemDispatch.vue?vue&type=template&id=a1e93568&", function () {
      api.rerender('a1e93568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reports/SettingsSystemDispatch.vue"
export default component.exports